module.exports = __webpack_public_path__ + "static/media/scan.30cb6928.png";